jQuery(function ($) {
  function getSlidesPerView() {
    var w = window.innerWidth;
    if (w >= 990) return 3;
    if (w >= 750) return 2;
    return 1;
  }

  $('.promo-slider').each(function () {
    var $slider = $(this);
    var $track  = $slider.find('.promo-slider-wrapper');

    var $prevBtn = $slider.find('.promo-slider-arrows button').eq(0);
    var $nextBtn = $slider.find('.promo-slider-arrows button').eq(1);

    var originalHTML = $track.html();

    var originalCount = 0;
    var slidesPerView = getSlidesPerView();
    var cloneCount = 0;

    var index = 0;
    var isAnimating = false;

    var step = 0;

    var LEFT_CLASS = 'is-left-of-active';

    var lastDirection = 0;          // 1 = next, -1 = prev
    var pendingClassUpdate = false; // if true, update class on transitionend

    // -------------------------
    // Autoplay
    // -------------------------
    var autoplayMs = 0;
    var autoplayTimer = null;
    var autoplayPaused = false;

    function readAutoplayMs() {
      // data-speed in .promo-slider-wrapper
      var v = $track.attr('data-speed');
      var ms = parseInt(v, 10);
      return isNaN(ms) ? 0 : ms;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      autoplayMs = readAutoplayMs();

      if (!autoplayMs || autoplayMs <= 0) return;
      if (originalCount <= 1) return;

      autoplayTimer = setInterval(function () {
        if (autoplayPaused) return;
        if (document.hidden) return;
        if (isAnimating) return;

        next();
      }, autoplayMs);
    }

    function restartAutoplay() {
      // common UX: if user interacts, reset the interval so it doesn’t immediately move again
      startAutoplay();
    }

    function setAutoplayPaused(paused) {
      autoplayPaused = !!paused;
    }

    // Pause on hover / focus (desktop)
    $slider.on('mouseenter', function () { setAutoplayPaused(true); });
    $slider.on('mouseleave', function () { setAutoplayPaused(false); });
    $slider.on('focusin',  function () { setAutoplayPaused(true); });
    $slider.on('focusout', function () { setAutoplayPaused(false); });

    // Pause while touching (mobile)
    $slider.on('touchstart', function () { setAutoplayPaused(true); });
    $slider.on('touchend touchcancel', function () { setAutoplayPaused(false); });

    document.addEventListener('visibilitychange', function () {
      // no need to do anything fancy; interval checks document.hidden
      // but pausing here avoids a “late tick” right after switching back
      if (document.hidden) setAutoplayPaused(true);
      else setAutoplayPaused(false);
    });

    function setTransition(on) {
      $track.css('transition', on ? 'transform 0.35s ease' : 'none');
    }

    function getGapPx() {
      var gap = window.getComputedStyle($track[0]).gap || '0px';
      var first = gap.split(' ')[0];
      var px = parseFloat(first);
      return isNaN(px) ? 0 : px;
    }

    function measure() {
      var $slides = $track.find('.promo-slide');
      var w = $slides.eq(0).outerWidth() || 0;
      var g = getGapPx();
      step = Math.round(w + g);
    }

    function translateTo(i) {
      var x = Math.round(-(i * step));
      $track.css('transform', 'translate3d(' + x + 'px, 0, 0)');
    }

    function updateLeftOfActiveClass() {
      var $allSlides = $track.find('.promo-slide');
      var leftIndex = index - 1;

      $allSlides.removeClass(LEFT_CLASS);

      if (leftIndex >= 0 && leftIndex < $allSlides.length) {
        $allSlides.eq(leftIndex).addClass(LEFT_CLASS);
      }
    }

    function rebuild() {
      slidesPerView = getSlidesPerView();

      // Restore originals
      $track.html(originalHTML);

      var $originalSlides = $track.find('.promo-slide');
      originalCount = $originalSlides.length;

      // Clone on both ends to allow infinite prev/next,
      // while starting at the first real slide (no left-peek on load).
      cloneCount = Math.min(originalCount, slidesPerView + 2);

      if (originalCount > 1 && cloneCount > 0) {
        var $endClones = $originalSlides.slice(0, cloneCount).clone().addClass('is-clone');
        $track.append($endClones);

        var $startClones = $originalSlides.slice(-cloneCount).clone().addClass('is-clone');
        $track.prepend($startClones);
      }

      // Start at first real slide (after prepended clones)
      index = cloneCount;

      setTransition(false);
      measure();
      translateTo(index);
      $track[0].offsetHeight;
      setTransition(true);

      // On load, set the class immediately
      updateLeftOfActiveClass();

      isAnimating = false;
      pendingClassUpdate = false;
      lastDirection = 0;

      // (Re)start autoplay based on current data-speed + slide count
      startAutoplay();
    }

    function goTo(nextIndex, direction) {
      if (isAnimating || originalCount <= 1) return;

      lastDirection = direction || 0;

      // NEXT => update class after movement completes
      pendingClassUpdate = (lastDirection === 1);

      isAnimating = true;
      index = nextIndex;
      translateTo(index);

      // PREV => update immediately
      if (lastDirection === -1) {
        updateLeftOfActiveClass();
      }
    }

    function next() {
      goTo(index + 1, 1);
    }

    function prev() {
      if (originalCount <= 1) return;

      // If at first real slide, jump to end-equivalent position (no animation), then animate one step left.
      if (index === cloneCount) {
        setTransition(false);
        index = cloneCount + originalCount;
        translateTo(index);
        $track[0].offsetHeight;
        setTransition(true);
      }

      goTo(index - 1, -1);
    }

    // Arrows
    $nextBtn.on('click', function (e) {
      e.preventDefault();
      next();
      restartAutoplay();
    });

    $prevBtn.on('click', function (e) {
      e.preventDefault();
      prev();
      restartAutoplay();
    });

    // Snap when entering clone territory + apply delayed class update for NEXT
    $track.on('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
      // Only respond to the track's own transition
      if (e.target !== $track[0]) return;

      var minRealIndex = cloneCount;
      var maxRealIndex = cloneCount + originalCount - 1;

      // Too far right into end clones -> snap back
      if (index > maxRealIndex) {
        setTransition(false);
        index = index - originalCount;
        translateTo(index);
        $track[0].offsetHeight;
        setTransition(true);
      }

      // Too far left into start clones -> snap forward
      if (index < minRealIndex) {
        setTransition(false);
        index = index + originalCount;
        translateTo(index);
        $track[0].offsetHeight;
        setTransition(true);
      }

      // NEXT => update class only after movement completes (and after any snap)
      if (pendingClassUpdate) {
        updateLeftOfActiveClass();
        pendingClassUpdate = false;
      }

      isAnimating = false;
    });

    // Swipe (touch)
    var startX = null;
    var startY = null;

    $slider.on('touchstart', function (e) {
      var t = e.originalEvent.touches && e.originalEvent.touches[0];
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
    });

    $slider.on('touchend', function (e) {
      if (startX === null) return;

      var t = e.originalEvent.changedTouches && e.originalEvent.changedTouches[0];
      if (!t) return;

      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      // ignore vertical scroll gestures
      if (Math.abs(dy) > Math.abs(dx)) {
        startX = null; startY = null;
        return;
      }

      var threshold = 40;
      if (dx <= -threshold) { next(); restartAutoplay(); }
      else if (dx >= threshold) { prev(); restartAutoplay(); }

      startX = null;
      startY = null;
    });

    // Init + resize rebuild
    rebuild();

    $(window).on('resize', function () {
      clearTimeout($slider.data('promoResizeTimer'));
      $slider.data('promoResizeTimer', setTimeout(rebuild, 120));
    });

    $(window).on('unload', function () {
      stopAutoplay();
    });
  });
});
